import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Dialog, DialogTitle, IconButton, DialogContent, Tooltip, Button, } from '@mui/material';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import RichTextViewer from '../../../components/RichTextViewer';
export var OrientacoesModal = function (_a) {
    var servico = _a.servico;
    var _b = useState(false), openDialog = _b[0], setOpenDialog = _b[1];
    var handleCloseDialog = function () { return setOpenDialog(false); };
    var handleOpenDialog = function () { return setOpenDialog(true); };
    if (!(servico === null || servico === void 0 ? void 0 : servico.orientacoes)) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: "Clique para ver as orienta\u00E7\u00F5es", arrow: true, children: _jsx(Button, { onClick: handleOpenDialog, startIcon: _jsx(HelpOutlineIcon, {}), children: "Orienta\u00E7\u00F5es" }) }), _jsxs(Dialog, { open: openDialog, onClose: handleCloseDialog, maxWidth: "lg", fullWidth: true, children: [_jsx(DialogTitle, { children: "Orienta\u00E7\u00F5es" }), _jsx(IconButton, { "aria-label": "close", onClick: handleCloseDialog, sx: function (theme) { return ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        }); }, children: _jsx(CloseIcon, {}) }), _jsx(DialogContent, { dividers: true, children: _jsx(RichTextViewer, { content: servico === null || servico === void 0 ? void 0 : servico.orientacoes, compact: true }) })] })] }));
};
